import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    labels: Array,
    appointments: Array,
    contacts: Array
  }

  connect() {
    this.renderChart()
  }

  renderChart() {
    const ctx = this.element.getContext("2d")

    // Create gradients
    const appointmentsGradient = ctx.createLinearGradient(0, 0, 0, 400)
    appointmentsGradient.addColorStop(0, "rgba(255, 197, 38, 0.2)")
    appointmentsGradient.addColorStop(1, "rgba(255, 197, 38, 0)")

    const contactsGradient = ctx.createLinearGradient(0, 0, 0, 400)
    contactsGradient.addColorStop(0, "rgba(34, 197, 94, 0.2)")
    contactsGradient.addColorStop(1, "rgba(34, 197, 94, 0)")

    new Chart(ctx, {
      type: "line",
      data: {
        labels: this.labelsValue,
        datasets: [
          {
            label: "Rendez-vous",
            data: this.appointmentsValue,
            borderColor: "#FFC526",
            backgroundColor: appointmentsGradient,
            borderWidth: 2,
            fill: true,
            tension: 0.4,
            pointRadius: 4,
            pointBackgroundColor: "#FFC526",
            pointBorderColor: "#fff",
            pointBorderWidth: 2,
            pointHoverRadius: 6
          },
          {
            label: "Contacts",
            data: this.contactsValue,
            borderColor: "#22C55E",
            backgroundColor: contactsGradient,
            borderWidth: 2,
            fill: true,
            tension: 0.4,
            pointRadius: 4,
            pointBackgroundColor: "#22C55E",
            pointBorderColor: "#fff",
            pointBorderWidth: 2,
            pointHoverRadius: 6
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          legend: {
            display: true,
            position: "top"
          },
          tooltip: {
            mode: "index",
            intersect: false
          }
        },
        scales: {
          y: {
            beginAtZero: true,
            ticks: {
              precision: 0
            }
          }
        },
        interaction: {
          mode: "nearest",
          axis: "x",
          intersect: false
        }
      }
    })
  }
}
